import axios from '@axios'

const PREFIX = '/municipios'

export default {

  getMunicipiosResumidos(filtro, externo) {
    if (externo) {
      return axios.post(`${PREFIX}/portal-propostas/resumido`, filtro)
    }
    return axios.post(`${PREFIX}/resumido`, filtro)
  },
}
